import React from "react";
import HhIcon from "../../../../components/HhIcon/HhIcon";
import { ReactComponent as Star } from "../../../../../images/icons/nav_bar-star.svg";
import trud_vsem_icon from "../../../../../images/icons/trud_vsem-icon.svg";
import { defaultFuncAndData } from "../../../../../utils/defaultData";
import SkillBlockVacancy from "../../ReuseComponents/SkillBlockVacancy";
import "./CardVacancy.scss";
import { useDispatch, useSelector } from "react-redux";
import { setActiveVacancy } from "../../../../redux/actions/searchProfessionActions";

function CardVacancySection({
  vacancy,
  userSkills,
  handleAddSkillTraektory,
  setCoordsTagAnimation,
  handleChangeFavoriteVacancy,
  favoriteVacancy,
}) {
  const { activeVacancy } = useSelector((state) => state.SearchProfession);
  const dispatch = useDispatch();
  console.log("activeVacancy", activeVacancy);
  const isActive = activeVacancy?.id === vacancy?.id;
  return (
    <li
      // className={s.card + (isActive ? s.target : "")}
      className={`card_vacancyc ${isActive ? "target" : ""}`}
      onClick={() => {
        dispatch(setActiveVacancy(null));
        setTimeout(() => {
          dispatch(setActiveVacancy(vacancy));
        }, 300);
      }}
    >
      <div className={"header"} id={vacancy?.id}>
        <span>{vacancy?.name}</span>
        <div className={"title_vacancy"}>
          <div className={"wrapper_link"}>
            <a
              href={vacancy?.alternate_url}
              className={"header_link"}
              target="_blank"
              rel="noopener noreferrer"
            >
              Открыть на
            </a>
            {vacancy.alternate_url.includes("hh.ru") ? (
              <HhIcon width={20} height={10} />
            ) : (
              <img src={trud_vsem_icon} alt="trud" />
            )}
          </div>
          <div className={"star_back"}>
            <Star
              width={14}
              height={14}
              onClick={(e) => {
                e.stopPropagation();
                handleChangeFavoriteVacancy(vacancy);
              }}
              className={
                defaultFuncAndData.calcActiveFavoriteIcon(
                  vacancy,
                  favoriteVacancy
                )
                  ? "active"
                  : ""
              }
            />
          </div>
        </div>
      </div>
      <div className={"salary"}>
        {defaultFuncAndData.calcSalarysVacancy(vacancy)} &nbsp;
        {/* <span>{vacancy?.salary?.to}</span>&nbsp; - &nbsp;
      <span>{vacancy?.salary?.from}</span> &nbsp; &nbsp; */}
        <span>{vacancy?.employer?.name}</span>
      </div>
      <SkillBlockVacancy
        userSkills={userSkills || []}
        needSkillsThisVacansy={(vacancy && vacancy.skills) || []}
        addSkillTraektory={(skill) => handleAddSkillTraektory(skill, true)}
        setCoordsTagAnimation={(e) => setCoordsTagAnimation(e)}
        needAnimation={true}
      />
    </li>
  );
}

export default CardVacancySection;
